// const SERVER_ADDRESS = "http://localhost";

const SERVER_ADDRESS = "http://api.pkugujian.com";

export default SERVER_ADDRESS;
